module.exports = __webpack_public_path__ + "img/shenqing.90f3faf5.png";